import { R2_URL } from "@/lib/api";

export function productImgUrl(product, size = 'home') {
  if (!product?.cover_image || !R2_URL) return null;
  if (size === 'original') return `${R2_URL}/p/${product.cover_image}`;
  const sizeFile = product.cover_sizes?.[size];
  return sizeFile ? `${R2_URL}/p/${sizeFile}` : null;
}
